import React from 'react';
import '../styles/Sponsors.css';

const Sponsors = () => {
  const sponsors = [
    {
      id: 1,
      image: 'assets/sponsor5.jpg',
      title: 'Clothing Partner',
      row: 1
    },
    {
      id: 2,
      image: 'assets/sponsor7.jpeg',
      title: 'Beverage Partner',
      row: 1
    },
    {
      id: 3,
      image: 'assets/sponsor6.jpg',
      title: 'Media Partner',
      row: 1
    },
    {
      id: 4,
      image: 'assets/sponsor2.png',
      title: 'Fitness Partner',
      row: 1
    },
    {
      id: 5,
      image: 'assets/sponsor3.jpg',
      row: 2
    },
    {
      id: 6,
      image: 'assets/sponsor4.png',
      row: 2
    },
    {
      id: 7,
      image: 'assets/sponsor8.jpg',
      row: 2
    },
    {
      id: 8,
      image: 'assets/sponsor1.png',
      row: 2
    }
  ];

  // Group sponsors by row
  const sponsorsByRow = sponsors.reduce((acc, sponsor) => {
    if (!acc[sponsor.row]) {
      acc[sponsor.row] = [];
    }
    acc[sponsor.row].push(sponsor);
    return acc;
  }, {});

  return (
    <section id="sponsors" className="sponsors-section">
      <div className="container">
        <h2 className="section-title">Our Sponsors</h2>
        <div className="sponsors-grid">
          {Object.entries(sponsorsByRow).map(([row, rowSponsors]) => (
            <div key={`row-${row}`} className="sponsor-row">
              {rowSponsors.map((sponsor) => (
                <div key={sponsor.id} className="sponsor-item">
                  <div className="sponsor-image-container">
                    <img 
                      src={sponsor.image} 
                      alt={`Sponsor ${sponsor.id}`} 
                      className="sponsor-image"
                      onError={(e) => {
                        e.target.onerror = null; 
                        e.target.src = 'path/to/placeholder.jpg';
                      }}
                    />
                  </div>
                  {sponsor.title && <p className="sponsor-title">{sponsor.title}</p>}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sponsors;
